import axios from "../../lib/axiosInstance";

export function getFreelanceCompanyMembers({
  page = 1,
  limit = 20,
  search = "",
  approvedOnly = false,
  workOrderId,
  sortBy,
  sortOrder,
  columns,
} = {}) {
  return axios
    .get("freelanceCompany/members", {
      params: {
        page,
        limit,
        search,
        approvedOnly,
        ...(workOrderId ? { workOrderId } : {}),
        ...(sortBy && sortOrder ? { sortBy, sortOrder } : {}),
        ...(columns?.length ? { columns: [].concat(columns).join(",") } : {}),
      },
    })
    .then((res) => res.data);
}

export function createLinkedEngineer(payload) {
  return axios.post("freelanceCompany/createEngineer", payload).then((res) => res.data);
}

export function getAdminFreelanceCompanies({ page = 1, limit = 20, search = "" } = {}) {
  return axios
    .get("freelanceCompany/admin/companies", { params: { page, limit, search } })
    .then((res) => res.data);
}

export function getFreelanceCompanies({ page = 1, limit = 20, search = "" } = {}) {
  return axios
    .get("freelanceCompany/companies", { params: { page, limit, search } })
    .then((res) => res.data);
}

export function getAdminFreelanceCompanyMembers(
  companyId,
  {
    page = 1,
    limit = 20,
    search = "",
    approvedOnly = false,
    fullName,
    email,
    status,
    excludeOwner = false,
  } = {},
) {
  return axios
    .get(`freelanceCompany/admin/companies/${companyId}/members`, {
      params: {
        page,
        limit,
        search,
        ...(approvedOnly ? { approvedOnly: true } : {}),
        ...(excludeOwner ? { excludeOwner: true } : {}),
        ...(fullName && { fullName }),
        ...(email && { email }),
        ...(status && { status }),
      },
    })
    .then((res) => res.data);
}

export function routeWorkOrderToMember(payload) {
  return axios.post("freelanceCompany/route", payload).then((res) => res.data);
}

export function assignMemberToWorkOrder(payload) {
  return axios.post("freelanceCompany/assign", payload).then((res) => res.data);
}
